import { render, staticRenderFns } from "./TaskFilters.vue?vue&type=template&id=6c0c37dc&scoped=true"
import script from "./TaskFilters.vue?vue&type=script&lang=js"
export * from "./TaskFilters.vue?vue&type=script&lang=js"
import style0 from "./TaskFilters.vue?vue&type=style&index=0&id=6c0c37dc&prod&lang=scss&scoped=true"
import style1 from "./TaskFilters.vue?vue&type=style&index=1&id=6c0c37dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c37dc",
  null
  
)

export default component.exports